import { useEffect, useState } from 'react';
import { useActivityLiveStream } from '../hooks/useActivityLiveStream';
import { isDocumentVisibleForLive } from '../lib/activityLiveVisibility';

/** Mount inside AuthGuard to fan out activity live SSE app-wide. */
export default function ActivityLiveSubscriber() {
  const [visible, setVisible] = useState(() =>
    typeof document === 'undefined'
      ? true
      : isDocumentVisibleForLive(document.visibilityState)
  );

  useEffect(() => {
    const onVis = () => {
      setVisible(isDocumentVisibleForLive(document.visibilityState));
    };
    document.addEventListener('visibilitychange', onVis);
    return () => document.removeEventListener('visibilitychange', onVis);
  }, []);

  useActivityLiveStream({ enabled: visible });
  return null;
}
